import type { LiveReferentialFormResponse } from 'apiConnector/secondary-market/live/models';
import type { SecondaryMarketLiveInstantBookActions } from 'state/secondaryMarket/live/instantBook/instantBook.actions';
import type { SecondaryMarketLiveTradeActions } from 'state/secondaryMarket/live/trade/trade.action';
import { secondaryMarketActionsFactory } from 'state/secondaryMarket/shared/actions';

import type { SecondaryMarketRealtimeActions } from '../realtime/realtime.action';
import type { SecondaryMarketLiveAmendActions } from './amend/amend.actions';
import type { SecondaryMarketLiveCancellationsActions } from './cancellation/cancellations.actions';
import type { SecondaryMarketLiveFormActions } from './form/liveForm.actions';
import type { SecondaryMarketLiveKycActions } from './kyc/kyc.actions';
import type { SecondaryMarketLiveQuoteActions } from './quote/liveQuote.action';

export const liveActions = secondaryMarketActionsFactory<LiveReferentialFormResponse, 'LIVE'>('LIVE');
type TypeOfLiveActions = typeof liveActions;

export type SecondaryMarketLiveActions =
  | SecondaryMarketLiveInitFormFetchRequested
  | SecondaryMarketLiveInitFormFetched
  | SecondaryMarketLiveInitFormFetchedFailed
  | SecondaryMarketLiveReloadRequestedByOrderId
  | SecondaryMarketLiveFormActions
  | SecondaryMarketLiveQuoteActions
  | SecondaryMarketLiveTradeActions
  | SecondaryMarketLiveCancellationsActions
  | SecondaryMarketLiveInstantBookActions
  | SecondaryMarketLiveAmendActions
  | SecondaryMarketLiveKycActions
  | SecondaryMarketRealtimeActions;

export type SecondaryMarketLiveInitFormFetchRequested = ReturnType<TypeOfLiveActions['initFormFetchRequested']>;
export type SecondaryMarketLiveInitFormFetched = ReturnType<TypeOfLiveActions['initFormFetched']>;
export type SecondaryMarketLiveInitFormFetchedFailed = ReturnType<TypeOfLiveActions['initFormFetchedFailed']>;
export type SecondaryMarketLiveReloadRequestedByOrderId = ReturnType<
  TypeOfLiveActions['secondaryMarketReloadRequestedByOrderId']
>;
